<svg [lucideIcon]="icon()" [size]="resolvedSize()" [strokeWidth]="strokeWidth()"></svg>
